import React from "react"
import { bkMain, clBasic } from "./general"

export default function Actividad({ a, p }) {

    return (
        <div style={Sactualizacion}>
            {a}
            {p}
            Hay que ver que le permitimos hacer aqui, y si depende del tipo de usuario

        </div>
    )
}

const Sactualizacion = {
    position: "fixed",
    top: "12vh",
    left: "3.3vw",
    background: bkMain,
    width: "96vw",
    height: "88vh",
    color: clBasic

}